import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Flights from './pages/Flights';
import FlightForm from './pages/FlightForm';
import Drones from './pages/Drones';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Reports from './pages/Reports';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  if (user.must_change_password && !location.pathname.startsWith('/settings')) {
    return (
      <Layout>
        <Routes>
          <Route path="*" element={<Navigate to="/settings" replace />} />
        </Routes>
      </Layout>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/flights" replace />} />
        <Route path="/flights" element={<Flights />} />
        <Route path="/flights/new" element={<FlightForm />} />
        <Route path="/flights/:id/edit" element={<FlightForm />} />
        <Route path="/drones" element={<Drones />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin/users" element={<Users />} />
        <Route path="*" element={<Navigate to="/flights" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
